import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { format } from 'date-fns';
import { AttendanceSheetResponseDto } from '@/api.types';

interface IMyProps {
  show: boolean;
  folha: AttendanceSheetResponseDto;
  handleHide: (e: | React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement> | HTMLElement) => void;
}

export default function ModalHistorico({ show, folha, handleHide }: IMyProps) {

  return (
    <Modal show={show} size="xl" aria-labelledby="contained-modal-title-vcenter" onExit={handleHide} centered>
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Histórico de Alterações da Folha de Frequência
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Data</th>
              <th className="text-center">Ação</th>
              <th>Usuário</th>
              <th>Localização</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody className="table-group-divider">
            <tr>
              <th scope="row">
                {format(folha.criadoEm, 'dd/MM/yyyy HH:mm')}
              </th>
              <td className="text-center">Criação</td>
              <td>{folha.criadoPor?.id}</td>
              <td>-</td>
              <td>Criação da folha no sistema.</td>
            </tr>

            {folha.assinaturas && folha.assinaturas.map((assinatura, index_a) => {
              return (
                <tr key={index_a}>
                  <th scope="row">
                    {format(assinatura.criadoEm, 'dd/MM/yyyy HH:mm')}
                  </th>
                  <td className="text-center">Assinatura</td>
                  <td>{assinatura.perfilAssinante}</td>
                  <td>{assinatura.ip}</td>
                  <td>{assinatura.perfilAssinante}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
